import MdaeNumericBox from "./component";
import { INumberBoxOptions } from "devextreme-react/number-box";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeTextBoxProps extends INumberBoxOptions {
  id: string;
  mdaeNumberBoxTitle?: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
  MdaeNumberBoxTitleComponent?:any;
}
export default MdaeNumericBox;
